<div class="bg-white p-6 rounded-lg border border-slate-200 shadow-sm">
  <h3 class="text-lg font-bold text-slate-800 mb-4">Spending Breakdown</h3>
  <div class="flex items-center justify-center sm:justify-start sm:space-x-6">
    <div class="relative w-32 h-32">
        <svg class="w-full h-full" viewBox="0 0 36 36">
            <circle cx="18" cy="18" r="15.9155" class="stroke-current text-slate-100" stroke-width="3" fill="none"></circle>
            @for(segment of chartSegments(); track segment.name) {
                <circle
                    cx="18" cy="18" r="15.9155"
                    class="stroke-current transition-all duration-300"
                    [class]="segment.color"
                    [class.opacity-50]="hoveredCategory() && hoveredCategory() !== segment.name"
                    stroke-width="3.5"
                    fill="none"
                    [attr.stroke-dasharray]="segment.strokeDasharray"
                    [attr.stroke-dashoffset]="segment.strokeDashoffset"
                    transform="rotate(-90 18 18)"
                ></circle>
            }
        </svg>
        <div class="absolute inset-0 flex flex-col items-center justify-center">
            <span class="text-xs text-slate-500">Total</span>
            <span class="text-lg font-bold text-slate-800">${{ totalSpending().toFixed(2) }}</span>
        </div>
    </div>
    <div class="hidden sm:block flex-1">
      <ul class="space-y-2 text-sm">
        @for(item of spendingData(); track item.name) {
          <li 
            (mouseenter)="onMouseEnter(item.name)" 
            (mouseleave)="onMouseLeave()"
            class="flex items-center justify-between p-1 rounded-md transition-all"
            [class.bg-slate-100]="hoveredCategory() === item.name">
            <span class="flex items-center">
              <span class="w-2.5 h-2.5 rounded-full mr-2" [class]="item.color.replace('text-', 'bg-')"></span>
              <span class="text-slate-600">{{ item.name }}</span>
            </span>
            <span class="font-semibold text-slate-800">${{ item.amount.toFixed(2) }}</span>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
